/* eslint-disable max-len */
/* eslint-disable max-statements-per-line */
import React from 'react'

import cn from 'classnames'
import _ from 'lodash'
import Image from 'next/legacy/image';

import helper from '@utils/helper';

import Istyles from './inex.module.less'
import styles from '@styles/modules/communityTopic.module.css'

const CommunityDes = ({ data = {} }) => {
  let text = data?.text
  const newText = helper.parseHTMLString(text)
  const textArr = _.filter(newText?.child || [], function (items) { return items.node === 'text' && ((items.text || '').replace(/\n/g, '')).trim() !== '' })
  console.log(textArr)
  text = textArr[0]?.text || ''
  text = helper.replaceHtmlEntity(text);

  return (
    <>
            {
                data?.customerMisc && data?.customerMisc?.avatar
                  ? (
                    <Image
                        className={Istyles.hotImage}
                        width={25}
                        height={25}
                        src={data.customerMisc.avatar}
                        alt={data.customerMisc.nickName}
                    />
                    )
                  : (
                <Image
                    className={Istyles.hotImage}
                    width={25}
                    height={25}
                    src={require('@images/defaultAvatar.webp')}
                    alt=' '
                />
                    )
            }
            <div className={cn(styles.textCont, 'DINPro')}>{text}</div>
    </>
  )
}
export default CommunityDes
